var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5742 15.457L15 10.8828C14.0977 9.98047 12.75 9.80469 11.6641 10.3398L7.5 6.17578V3.75L2.5 0L-2.98023e-08 2.5L3.75 7.5H6.17578L10.3398 11.6641C9.80859 12.75 9.98047 14.0977 10.8828 15L15.457 19.5742C16.0273 20.1445 16.9492 20.1445 17.5156 19.5742L19.5742 17.5156C20.1406 16.9453 20.1406 16.0234 19.5742 15.457ZM12.957 8.78906C14.0625 8.78906 15.1016 9.21875 15.8828 10L16.6406 10.7578C17.2578 10.4883 17.8438 10.1133 18.3516 9.60547C19.8008 8.15625 20.293 6.11719 19.832 4.26562C19.7461 3.91406 19.3047 3.79297 19.0469 4.05078L16.1406 6.95703L13.4883 6.51562L13.0469 3.86328L15.9531 0.957031C16.2109 0.699219 16.0859 0.257812 15.7305 0.167969C13.8789 -0.289062 11.8398 0.203125 10.3945 1.64844C9.28125 2.76172 8.75781 4.23047 8.78516 5.69531L11.9922 8.90234C12.3086 8.82812 12.6367 8.78906 12.957 8.78906ZM8.89844 11.9922L6.68359 9.77734L0.730469 15.7344C-0.246094 16.7109 -0.246094 18.293 0.730469 19.2695C1.70703 20.2461 3.28906 20.2461 4.26562 19.2695L9.09375 14.4414C8.79688 13.6641 8.70703 12.8164 8.89844 11.9922ZM2.5 18.4375C1.98438 18.4375 1.5625 18.0156 1.5625 17.5C1.5625 16.9805 1.98047 16.5625 2.5 16.5625C3.01953 16.5625 3.4375 16.9805 3.4375 17.5C3.4375 18.0156 3.01953 18.4375 2.5 18.4375Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/s2.c7dc6c750a7f8fded1fb9220b52ed29b.svg";
export { ForwardRef as ReactComponent };